import { render, staticRenderFns } from "./AdamForm.vue?vue&type=template&id=ffda828c&"
import script from "./AdamForm.vue?vue&type=script&lang=js&"
export * from "./AdamForm.vue?vue&type=script&lang=js&"
import style0 from "./AdamForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports